const basePath = "/images/src/components/Awards/images";

const images = {
  award0: { url: `${basePath}/award0.svg`, width: 208, height: 131 },
  award1: { url: `${basePath}/award1.png`, width: 260, height: 126 },
  award2: { url: `${basePath}/award2.png`, width: 246, height: 126 },
  award3: { url: `${basePath}/award3.png`, width: 250, height: 250 },
  award4: { url: `${basePath}/award4.png`, width: 288, height: 242 },
  award5: { url: `${basePath}/award5.png`, width: 170, height: 86 },
  award6: { url: `${basePath}/award6.png`, width: 500, height: 150 },
  award7: { url: `${basePath}/award7.png`, width: 550, height: 293 },
  award8: { url: `${basePath}/award8.png`, width: 874, height: 334 },
  award9: { url: `${basePath}/award9.png`, width: 1080, height: 1080 },
  award10: { url: `${basePath}/award10.png`, width: 742, height: 500 },
  award11: { url: `${basePath}/award11.png`, width: 400, height: 200 },
};

const AWARDS = [
  {
    image: images.award0,
    title: "Remote Monitoring Security Solution of the Year",
  },
  {
    image: images.award6,
    title: "The National Cyber Awards AI product of the year 2023",
  },
  {
    image: images.award1,
    title: ["Winner of SigWiComp by the German Research Center for AI"].join(
      " ",
    ),
  },
  {
    image: images.award9,
    title: "BOLD Awards 2024 Boldest Healthtech",
    maxWidth: 135,
  },
  {
    image: images.award10,
    title: "BOLD Awards 2024 Boldest Cybersecurity",
    maxWidth: 135,
  },
  {
    image: images.award11,
    title: "Go:Tech Awards AI/Machine Learning",
    maxWidth: 135,
  },
  {
    image: images.award7,
    title:
      "Informatics in Medicine Unlocked - Detection of mild cognitive impairment based on mouse movement data",
    link: "https://www.sciencedirect.com/science/article/pii/S235291482200257X",
  },
  {
    image: images.award2,
    title: [
      "Winner of the Mouse Dynamics Challenge competition of Balabit",
    ].join(" "),
  },
  {
    image: images.award3,
    title: "Top 50 UK startups",
    maxWidth: 110,
  },
  {
    image: images.award4,
    title: "Top 10 CEE Scale-up by Vestbee",
    maxWidth: 145,
  },
  {
    image: images.award5,
    title:
      "Digital Alliance Prize by the Ministry of Technology and Innovation",
  },
  {
    image: images.award8,
    title:
      "Feature space reduction method for ultrahigh-dimensional, multiclass data: RFMS",
    link: "https://iopscience.iop.org/journal/2632-2153",
  },
  {
    image: images.award7,
    title:
      "SoftwareX - BiometricBlender: Ultra-high dimensional, multi-class synthetic data generator to imitate biometric feature space",
    link: "https://www.softxjournal.com/article/S2352-7110(23)00062-6/fulltext",
  },
  {
    image: images.award11,
    title: "The National Cyber Awards The Financial Services 2024",
  },
];

export default AWARDS;
